import { clsfy } from "../../helpers"
const EditorFeatureTitle = ({ title, className = '' }) => {
	return (
		<div className={clsfy(className, 'flex md:space-x-5 2xl:space-x-5')}>
			<h3 className='text-1b md:text-2xl 2xl:text-3xl font-bold leading-10'>{title}</h3>
			<div className='md:h-7 2xl:h-8 md:w-7 2xl:w-8 rounded-full bg-70 grid place-items-center text-white text-xs 2xl:text-sm'>
				<span className='inline-block mt-px'>?</span>
			</div>
		</div>
	)
}

export default EditorFeatureTitle